export default __webpack_public_path__ + "static/media/(20).ef7af1df.jpg";